import AbstractMediator from "../../../core/ui/AbstractMediator";
import EmailInteractionEvent from "../controller/EmailInteractionEvent";

export default class EmailDraftInputComponentMediator extends AbstractMediator {
    constructor(target, dispatcher, languagePack) {
        super(target, dispatcher);

        this._dispatcher = dispatcher;
        this._languagePack = languagePack;
        this._mcBlock = this._target.mcBlock;
    }

    initialize() {
        super.initialize();

        var buttonLabel;
        var selectedOption = this._mcBlock.getSelectedOption();
        var bounds;
        if (selectedOption != null) {
            buttonLabel = selectedOption.getDescription().getText();
            this._button = this.createSlice9Button(this._target, this._handleButtonClick.bind(this), buttonLabel); 
            bounds = this._button.getBounds();

            const upTextField = this._target.up.textfield;
            const newTextFieldBounds = upTextField.getBounds();
            const states = ['up', 'over', 'down', 'disabled'];
            for (let i = 0; i < states.length; i++) {
                const state = states[i];
                const stateSkin = this._target[state];
                if (!stateSkin) {
                    continue;
                }

                stateSkin.icon.y = newTextFieldBounds.height + upTextField.y;
            }
        } else {
            buttonLabel = this._languagePack.getText("email.pickAnswerLabel"); 
            this._button = this.createButton(this._target, this._handleButtonClick.bind(this), buttonLabel); 
            bounds = this._target.getBounds();
        }
        
        this._target.setBounds(bounds.x, bounds.y, bounds.width, bounds.height);
    }

    _handleButtonClick(evt) {
        this.dispatch(EmailInteractionEvent.OPEN_DRAFT_CHOICE_PICKER, {mcBlock: this._mcBlock});
    }
}